import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import GenericSelect from './GenericSelect'
import LocationStickers from '../LocationStickers'
import Details from '../Details'

class LocationSelect extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      selected: props.selected || null
    }

    // Bind events
    this.onChangeSelect = this.onChangeSelect.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    // Bubble local change to parent
    if (prevState.selected !== this.state.selected) {
      if (_.isFunction(this.props.onChange)) {
        this.props.onChange(this.state.selected)
      }
    }

    // Bubble parent change to local
    if (prevProps.selected !== this.props.selected) {
      this.setState({
        selected: this.props.selected
      })
    }
  }

  onChangeSelect(selectedStr) {
    let selected = Number(selectedStr)
    if (Number.isNaN(selected) && _.isString(selectedStr)) {
      selected = selectedStr
    }
    this.setState({
      selected
    })
  }

  render() {
    const { label, loading, options, selected, onChange, error, ...props } = this.props
    return (
      <GenericSelect
        label={label}
        loading={loading}
        options={
          _.map(options, (option) => ({
            key: String(option.id),
            value: (
              <span>
                <LocationStickers
                  stickers={option.stickers}
                />
                {
                  _.isArray(option.details)
                    ? _.map(option.details, (detail, idx) => (
                        <Details
                          key={idx}
                          icon={detail.icon}
                          action={Details.ACTION.HOVER}
                          content={detail.text}
                        />
                      ))
                    : null
                }
              </span>
            ),
            searchValue: _.map(option.stickers, (sticker) => (sticker.name)).join(' ')
          }))
        }
        selected={!_.isNull(this.state.selected) ? String(this.state.selected) : null}
        onChange={this.onChangeSelect}
        error={error}
        canSearch={true}
        reducedPadding={true}
        {...props}
      />
    )
  }
}

LocationSelect.propTypes = {
  label: PropTypes.string, // if missing, rendered without Form structure
  loading: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([
        PropTypes.number.isRequired,
        PropTypes.string.isRequired
      ]).isRequired,
      stickers: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          color: PropTypes.shape({
            foreground: PropTypes.string.isRequired,
            background: PropTypes.string.isRequired
          }).isRequired
        }).isRequired
      ).isRequired,
      details: PropTypes.arrayOf(
        PropTypes.shape({
          icon: PropTypes.oneOf([ 'info', 'success', 'warning', 'failure' ]).isRequired,
          text: PropTypes.string.isRequired
        })
      )
    }).isRequired
  ).isRequired,
  selected: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  useAddBtn: PropTypes.shape({
    onClick: PropTypes.func.isRequired,
    disabledMessage: PropTypes.string
  })
}

export default LocationSelect



// WEBPACK FOOTER //
// ./src/components/elements/forms/LocationSelect.js